'use strict';

var Marionette = require('backbone.marionette');

export default Marionette.View.extend({

  tagName: 'li',
  className: 'service-list-service',
  template: require('./templates/service-list-item.hbs'),
  events: {
    'click .service-list-expand .fa': 'onClickIcon',
  },
  triggers: {
    'change input': 'click:checkbox',
  },
  ui: {
    input: '.service-list-input',
    icon: '.service-list-expand .fa',
    description: '.service-list-description',
  },

  initialize: function (options) {
    this.appointment = options.appointment;

    this.listenTo(this.appointment, 'change:service_id', this.render);
  },

  serializeData: function () {
    var json = this.model.toJSON();
    json.currency = window.SETTINGS.currency;
    json.notFree = this.model.showPrice();

    if (json.upload && json.upload.path) {
      if (window.SETTINGS.uploads_prefix) {
        json.upload_url = window.SETTINGS.uploads_prefix + json.upload.path;
      } else {
        json.upload_url = json.upload.path;
      }
    }

    return json;
  },

  onRender: function () {
    if (this.appointment.hasService(this.model)) {
      this.ui.input.prop('checked', true);
    }

    if (this.appointment.hasService(this.model) ||
      this.appointment.canAddService(this.model)) {
      this.enable();
    } else {
      this.disable();
    }

    if (!this.model.has('description') || !this.model.get('description').trim()) {
      this.ui.icon.remove();
    }
  },

  onClickIcon: function (evt) {
    evt.preventDefault();
    this.toggleOpen();
  },

  isSelected: function () {
    return this.ui.input.prop('checked');
  },

  enable: function () {
    this.$el.removeClass('disabled');
    this.ui.input.prop('disabled', false);
  },

  disable: function () {
    this.$el.addClass('disabled');
    this.ui.input.prop('disabled', true);
  },

  toggleOpen: function () {
    this.ui.icon.toggleClass('fa-angle-down');
    this.ui.icon.toggleClass('fa-angle-up');
    this.ui.icon.attr('aria-expanded', !this.ui.icon.attr('aria-expanded'));
    this.ui.description.slideToggle();
  },

});
